import * as React from 'react'
import { buildProductionFolderUrl } from './folderUrls'

interface ProductionFilesButtonProps {
  jobnumber: {
    id: number
    order_number: string
  }
  className?: string
}

export default function ProductionFilesButton({ jobnumber, className }: ProductionFilesButtonProps) {
  if (!jobnumber.order_number) return null

  const buttonClass = `btn btn-outline-secondary${className ? ` ${className}` : ''}`
  const url = buildProductionFolderUrl(jobnumber.id, jobnumber.order_number)
  if (!url) return null

  return (
    <a className={buttonClass} href={url} target="_blank" rel="noopener noreferrer">
      <i className="fa fa-icon fa fa-folder-open mr-2" />
      Produktionsfiler
    </a>
  )
}
